import { createFileRoute } from '@tanstack/react-router';
import AttendanceRequestTable from '@/modules/attendance/attendance-waiting-approval/AttendanceWaitingApprovalTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/attendance/waiting-approval')({
  component: AttendanceRequestTable,
});
